import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type DocumentTemplateVersionSectionsUpdateFailedAction = {
	type: 'DOCUMENT_TEMPLATE_VERSION_SECTIONS_UPDATE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): DocumentTemplateVersionSectionsUpdateFailedAction => ({
	type: 'DOCUMENT_TEMPLATE_VERSION_SECTIONS_UPDATE_FAILED',
	payload,
});
